<script lang="ts">
	import { DeviceButton, ControlsContainer, DeviceButtonV2 } from '@Shelly/shelly-design-system';
	import { scenes } from 'src/stores/lists/scenes';
	import { postReq } from 'src/services/http';
	import { user_settings } from 'src/stores/account/user';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { format } from 'svelte-i18n';
	import DuplicateSceneWarningModal from 'src/components/Modals/DuplicateSceneWarningModal.svelte';
	import { useDuplicateSceneDetection } from 'src/helpers/useDuplicateSceneDetection';

	export let item;
	export let variant: 'listMenuCard' | 'drawer' | 'widgetCard' | 'dashControlWidget';

	let id = item?.id || item?._id;
	let loading = false;

	const hasPlayRights = !$user_settings.sub || item._meta?.rights?.run !== 0;

	// Use the composable hook for duplicate detection
	const { showWarningModal, duplicateInfo, checkDuplicateAndWarn, confirmAction, cancelAction } =
		useDuplicateSceneDetection();

	const runManual = async () => {
		try {
			if (id !== undefined && $scenes[id]) {
				loading = true;
				let run = await postReq('scene/manual_run', { id: id });
				// console.log('run scene block manualy ', await run);
				setTimeout(() => {
					loading = false;
				}, 1500);
			}
		} catch (error) {
			loading = false;
		}
	};

	const handleSceneRun = async (e) => {
		e.stopPropagation();

		// Use the centralized duplicate detection
		checkDuplicateAndWarn(id, $scenes, runManual, 'run');
	};

	const confirmRunDuplicate = () => {
		confirmAction();
	};

	const cancelRunDuplicate = () => {
		cancelAction();
	};
</script>

{#if variant === 'listMenuCard' || variant === 'widgetCard'}
	{#if $showNewLayout}
		<DeviceButtonV2
			id="devicebutton-k402a8p"
			aria-label={$format('run_scene', { default: 'Run Scene' })}
			icon="fas fa-play"
			variant="success"
			isActive={loading}
			slot="second"
			disabled={loading || !hasPlayRights}
			on:click={handleSceneRun}
		/>
	{:else}
		<DeviceButton
			id="devicebutton-k402a8p"
			aria-label={$format('run_scene', { default: 'Run Scene' })}
			icon="fas fa-play"
			variant="success"
			isActive={loading}
			slot="second"
			disabled={loading || !hasPlayRights}
			on:click={handleSceneRun}
		/>
	{/if}
{:else if variant === 'drawer'}
	{#if $showNewLayout}
		<ControlsContainer class="mt-m" color="color-0">
			<DeviceButtonV2
				id="devicebutton-k5v6t1r"
				aria-label={$format('run_scene', { default: 'Run Scene' })}
				class="justify-content-center"
				isWide
				size="l"
				slot="first"
				icon="fa fa-play"
				disabled={loading || !hasPlayRights}
				variant="success"
				isActive={loading}
				on:click={handleSceneRun}
			/>
		</ControlsContainer>{:else}
		<ControlsContainer class="mt-m">
			<DeviceButton
				id="devicebutton-k5v6t1r"
				aria-label={$format('run_scene', { default: 'Run Scene' })}
				class="justify-content-center"
				isWide
				size="l"
				slot="first"
				icon="fa fa-play"
				disabled={loading || !hasPlayRights}
				variant="success"
				isActive={loading}
				on:click={handleSceneRun}
			/>
		</ControlsContainer>
	{/if}
{:else if variant === 'dashControlWidget'}
	<DeviceButtonV2
		size="s"
		id="devicebutton-k402a8p"
		aria-label={$format('run_scene', { default: 'Run Scene' })}
		icon="fas fa-play"
		variant="success"
		isActive={loading}
		slot="second"
		disabled={loading || !hasPlayRights}
		on:click={handleSceneRun}
	/>
{/if}

<!-- Duplicate Scene Warning Modal -->
<DuplicateSceneWarningModal
	showModal={$showWarningModal}
	actionType="run"
	originalSceneName={$duplicateInfo?.originalName || ''}
	onConfirm={confirmRunDuplicate}
	onCancel={cancelRunDuplicate}
/>
